module.exports = __webpack_public_path__ + "static/media/loader.4d13f196.svg";